import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpParameterCodec, HttpParams, HttpRequest, HttpResponse } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { Injectable, Injector } from "@angular/core";
import { LogBookRootScopeService } from "app/shared/model/app.model";

@Injectable({
	providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor {
	constructor(
		protected injector: Injector
	) {}
	
	private get $rootScope(): LogBookRootScopeService {
        return this.injector.get('$rootScope');
	}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		let newParams = new HttpParams({ encoder: new HttpParamEncoder() })

		req.params.keys().forEach(key => {
			let values = req.params.getAll(key) as any[];
			
			values && values.forEach(value => {
				// Prevent empty array parameters from being set as paramName='undefined' in the query string
				if (value === undefined || value === null)
					return;
				
				// Converts date parameters to their equivalent ISO strings so server can interpret them correctly
				if (value instanceof Date)
					value = value.toISOString();
				// Allows ng service http request to show the AJS-controlled cog spinner while request is processing
				else if (key == 'useSpinner')
					this.$rootScope.ngSpinnerRequests++;
	
				newParams = newParams.append(key, value);
			});
		});

        req = req.clone({
            params: newParams
        })

        return next.handle(req)
	        .pipe(
	        	tap(r => {
					if (r instanceof HttpResponse) {
						if (req.params.get('useSpinner'))
							this.$rootScope.ngSpinnerRequests--;

						if (r.headers.get('content-type') == 'application/json')
							cleanHrefs(r.body);
						
						this.onSuccess(r);
					}
	        		return r;
	        	}),
				catchError(r => {
					if (req.params.get('useSpinner'))
						this.$rootScope.ngSpinnerRequests--;
					
					if (r instanceof HttpErrorResponse)
						this.onError(r);
					
					return throwError(r);
				})
			);
    }

    onSuccess(response: HttpResponse<any>): void {}

    onError(error: HttpErrorResponse): void {}
}

/**
 * Clean object link hrefs of '{?projection}'
 */
function cleanHrefs(obj: Record<any, any>) {
	if (obj == null) return;
	Object.keys(obj).forEach((key) => {
		const value = obj[key];
		
		if (typeof value === 'string') {
			obj[key] = clean(value);
		}
		else if (value != null && typeof value === 'object')
			cleanHrefs(value);
			
	});
	
	function clean(x: string | any) {
		if (typeof x !== "string") return x;
		return x.toString().replace('{?projection}', '');
	}
}

/**
 * Class to handle HttpParam encoding for dates as LogBook does not accept date formats in the way
 * Angular sends them normally.
 */
class HttpParamEncoder implements HttpParameterCodec {
    decodeKey(key: string): string {
        return decodeURIComponent(key);
    }

    decodeValue(value: string): string {
        return decodeURIComponent(value);
    }

    encodeKey(key: string): string {
        return encodeURIComponent(key);
    }

    encodeValue(value: string): string {
        return encodeURIComponent(value);
    }
}